import { render, staticRenderFns } from "./courses-component.vue?vue&type=template&id=623d8488&scoped=true"
import script from "./courses-component.vue?vue&type=script&lang=js"
export * from "./courses-component.vue?vue&type=script&lang=js"
import style0 from "./courses-component.vue?vue&type=style&index=0&id=623d8488&prod&scoped=true&lang=css"
import style1 from "./courses-component.vue?vue&type=style&index=1&id=623d8488&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "623d8488",
  null
  
)

export default component.exports